export default __webpack_public_path__ + "static/media/Mark-2-HUD-Diagnostic Widget.7a576c76.jpg";